@if (title) {
  <h2 class="content-card__header">
    {{ title }}
  </h2>
  <mat-divider></mat-divider>
}

<form [formGroup]="formGroup">
  <div class="row">
    <div class="col-12 col-lg-12">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'Country' | translate }}</mat-label>
        <mat-select formControlName="country">
          @for (country of listOfCountries$ | async; track country) {
            <mat-option [value]="country.Id"> {{ country.Name }} </mat-option>
          }
        </mat-select>
        @if (countryControl.invalid && countryControl.touched) {
          <mat-error>
            {{ 'InvalidField' | translate }}
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>

  @switch (countryControl.value) {
    @case (Country.Poland) {
      <app-polish-adress-form formGroupName="polishAddress" [address]="address"></app-polish-adress-form>
    }
    @default {
      <app-abroad-adress-form formGroupName="abroadAddress" [address]="address"></app-abroad-adress-form>
    }
  }
</form>
